import React, { useState,useEffect, useRef } from "react";
import EmailCard from "./EmailCard";
import { useDispatch } from "react-redux";
import { setReadStatusThunk } from "../../store/features/emailsSlice";
import { groupEmailsByTime } from "../../utils/emailUtils";

const EmailList = ({ emails, pinnedEmailIds, currentEmailId, onTogglePin, threadId }) => {
  const dispatch = useDispatch();
  const latestEmailRef = useRef(null);

  useEffect(() => {
    if (latestEmailRef.current) {
      latestEmailRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [emails]);

  // Mark emails as read when opened
  const handleEmailOpen = (email) => {
    if (email.readStatus === "unread") {
      dispatch(setReadStatusThunk(threadId, email.id)); // Use thunk for persistence
    }
  };

  // Separate pinned and unpinned emails
  const pinnedEmails = emails.filter((email) => pinnedEmailIds.includes(email.id));
  
  const unpinnedEmails = emails.filter((email) => !pinnedEmailIds.includes(email.id));

  return (
    <div className="flex flex-col gap-4">
      {/* Pinned Emails */}
      {pinnedEmails.length > 0 && (
        <div>
          <h3 className="text-lg font-bold mb-2">Pinned</h3>
          {pinnedEmails.map((email) => (
            <EmailCard
              key={email.id}
              email={email}
              isPinned
              isHighlighted={currentEmailId === email.id}
              onTogglePin={onTogglePin}
              threadId={threadId}
            />
          ))}
        </div>
      )}

      {/* Unpinned Emails */}
      {unpinnedEmails.length > 0 && (
        <div>
          {unpinnedEmails.map((email, index) => (
            <EmailCard
              key={email.id}
              email={email}
              isHighlighted={currentEmailId === email.id}
              onTogglePin={onTogglePin}
              onOpen={() => handleEmailOpen(email)}
              ref={index === unpinnedEmails.length - 1 ? latestEmailRef : null}
              threadId={threadId}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default EmailList;
